<template>
  <div v-loading="isLoading" class="agent-reference-list">
    <div v-if="!isLoading" class="agent-reference-list__content">
      <div class="agent-reference-list__title">
        {{ isForce ? 'Агент реферала' : 'Рефералы агента' }}
      </div>
      <div v-if="!referrals.length && !isLoading" class="agent-reference-list">Нет рефералов</div>
      <el-table v-else :data="referrals" style="width: 100%" class="agent-reference-list__table">
        <el-table-column width="auto">
          <template slot="header"> Email </template>
          <template slot-scope="scope">
            <div class="agent-reference-list__email cell" @click="setSearchQuery(scope.row.email)">
              {{ scope.row.email }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import ButtonElement from '@/components/elements/ButtonElement';
import axios from 'axios';
import { mapState, mapMutations, mapActions } from 'vuex';
import fixDateFormat from '@/mixin/fixDate';

export default {
  name: 'AgentReferenceList',
  mixins: [fixDateFormat],
  data() {
    return {
      isLoading: true,
      referrals: [],
    };
  },
  computed: {
    isForce() {
      return this.$route.query.force === 'true';
    },
  },
  watch: {
    async '$route.query.agent_id'(agent_id) {
      if (this.referrals.length) return;

      const clientToken = localStorage.getItem('token');
      const data = {
        token: clientToken,
        agent_id,
      };

      try {
        if (this.isForce) {
          const response = await this.$store.dispatch('Referrals/getUserByAgentId', data);
          this.referrals = [response.data.data.user];
        } else {
          const response = await this.$store.dispatch('Referrals/getUsersByAgentId', data);
          this.referrals = response.data.data;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
  },
  methods: {
    async setSearchQuery(email) {
      const { agent_id, force, role, ...rest } = this.$route.query;
      this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: false });

      await this.$router.push({
        name: 'ClientsInfo',
        query: {
          ...rest,
          page: 1,
          search: email,
        },
      });
    },
  },
  async beforeDestroy() {
    const { agent_id, force, ...rest } = this.$route.query;
    await this.$router.push({ query: { ...rest } });
  },
};
</script>
<style lang="scss">
.agent-reference-list__table.el-table td:last-child {
  text-align: left;
}
</style>
<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.agent-reference-list {
  background: #fff;
  color: #000;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;

  &__title {
    font-weight: 700;
    font-size: 3rem;
    line-height: 3.5rem;
    margin-bottom: 5rem;
  }

  &__content {
    padding: 7rem 6rem;
  }

  &__email {
    cursor: pointer;
  }
}
</style>
